import { render, staticRenderFns } from "./personal_home.vue?vue&type=template&id=ef8704e2&scoped=true&"
import script from "./personal_home.vue?vue&type=script&lang=js&"
export * from "./personal_home.vue?vue&type=script&lang=js&"
import style0 from "./personal_home.vue?vue&type=style&index=0&id=ef8704e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8704e2",
  null
  
)

export default component.exports